<template>
  <b-modal ref="modal" :id="modalId" centered title="Submit Coaching" @hide="$emit('close')" hide-header-close>
    <div v-if="selectedItems" class="d-flex flex-column gap-3">
      <span>Apakah Anda yakin ingin mengirim coaching ini?</span>
      <ul>
        <li v-for="item in selectedItems || []" :key="item.id">
          {{ item?.coaching?.title || item?.id }}
        </li>
      </ul>
    </div>

    <template #modal-footer>
      <div class="d-flex justify-content-end align-items-center w-100">
        <b-button variant="primary" :disabled="isSubmitting" @click="handleSubmit"> Submit </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { titleCase } from "@/utils/titleCase";

export default {
  name: "ConfirmationSubmitModal",
  props: {
    modalId: { type: String, default: "confirmation-submit-modal" },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    titleCase,
    handleSubmit() {
      const ids = this.selectedItems.map((row) => row.id);

      this.$emit("submit", ids);
    },
  },
};
</script>

<style scoped>
.gap-2 > * + * {
  margin-left: 0.5rem;
}

.table td {
  padding: 0.5rem 0;
}

.d-flex.flex-wrap {
  row-gap: 0.25rem;
  column-gap: 0.25rem;
}

.completion-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>
